import React, { Children, useId } from 'react';
import classnames from 'classnames';
import { wrapWithComponent } from '../utils';
import { Item } from '../Item';
import styles from '../styles.module.sass';

export interface GroupProps {
    children?: React.ReactNode;
    condensed?: boolean;
    title?: string;
    helpText?: React.ReactNode;
}

export function Group({ children, condensed, title, helpText }: GroupProps) {
    const className = classnames(condensed ? styles.condensed : styles.grouped);

    const id = useId();

    let helpTextElement = null;
    let helpTextID: undefined | string;
    let titleElement = null;
    let titleID: undefined | string;

    if (helpText) {
        helpTextID = `${id}HelpText`;
        helpTextElement = <div id={helpTextID}>{helpText}</div>;
    }

    if (title) {
        titleID = `${id}Title`;
        titleElement = (
            <div id={titleID} className={styles.Title}>
                {title}
            </div>
        );
    }

    const itemsMarkup = Children.map(children, (child) => wrapWithComponent(child, Item, {}));

    return (
        <div role="group" className={className} aria-labelledby={titleID} aria-describedby={helpTextID}>
            {titleElement}
            <div className={styles.Items}>{itemsMarkup}</div>
            {helpTextElement}
        </div>
    );
}
